var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13013",
    "data-name": "Group 13013",
    transform: "translate(-1823 -739.66)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3213",
    "data-name": "Rectangle 3213",
    width: 41,
    height: 36,
    rx: 3,
    transform: "translate(1823 739.66)",
    fill: "#2468ff",
    opacity: 0.072
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812",
    transform: "translate(1835 749.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37619",
    "data-name": "Path 37619",
    d: "M9.172,7.137V0H7.137V7.137H0V9.172H7.137v7.137H9.172V9.172h7.137V7.137Z",
    fill: "#2179fe"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.3cb2cf1f.svg";
export { ForwardRef as ReactComponent };